import mapboxgl from "mapbox-gl";

export const removeUndoMarker = (state) => {
    if (state.undoMarker) {
        state.undoMarker.remove();
        state.undoMarker = null;
    }
    state.previousCoordinates = null;
};

export const showUndoMarker = (map, state, coord) => {
    const prevCoords = state.previousCoordinates;
    if (!prevCoords) return;

    const btn = document.createElement("button");
    btn.textContent = "\u21a9";
    btn.title = "Undo";
    btn.style.cssText =
        "background:#fff;border:1px solid #ccc;border-radius:4px;cursor:pointer;font-size:16px;padding:2px 6px;box-shadow:0 1px 3px rgba(0,0,0,0.3)";

    btn.addEventListener("mousedown", (e) => {
        e.stopPropagation();
    });

    btn.addEventListener("click", (e) => {
        e.stopPropagation();
        state.feature.setCoordinates(prevCoords);
        if (state.previousRectangle) {
            state.rectangle = state.previousRectangle;
            state.previousRectangle = null;
        }

        removeUndoMarker(state);
        map.fire("draw.undo", {
            features: [state.feature.toGeoJSON()],
        });
    });

    if (state.undoMarker) {
        state.undoMarker.remove();
    }
    state.undoMarker = new mapboxgl.Marker({ element: btn, anchor: "bottom" }).setLngLat(coord).addTo(map);
};
